import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { initialize, PageTypes } from "@/onboarding/features/cost_analysis/Slice"
import { getCostAnalysis } from "@/onboarding/features/cost_analysis/selectors"
import LoadingSpinner from "@/components/LoadingSpinner"

import Comparison from "./components/Comparison"
import Dashboard from "./components/Dashboard"

const Season = ({ season, selectedBiddingRegionId, selectedAwardSetId }): JSX.Element => {
  const dispatch = useDispatch()

  const { initialized, page } = useSelector(getCostAnalysis)

  useEffect(() => {
    if (!initialized) {
      dispatch(
        initialize({
          season,
          selectedBiddingRegionId,
          selectedAwardSetId,
        })
      )
    }
  }, [initialized])

  if (!initialized) {
    return <LoadingSpinner />
  }

  if (page === PageTypes.COMPARISON) {
    return <Comparison />
  }

  return <Dashboard />
}

export default Season
